import { render } from "./BaseAddressForm.vue?vue&type=template&id=0b020fa8"
import script from "./BaseAddressForm.vue?vue&type=script&lang=js"
export * from "./BaseAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseAddressForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b020fa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b020fa8', __exports__)) {
    console.log('reload')
    api.reload('0b020fa8', __exports__)
  }
  
  module.hot.accept("./BaseAddressForm.vue?vue&type=template&id=0b020fa8", () => {
    console.log('re-render')
    api.rerender('0b020fa8', render)
  })

}


export default __exports__